// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/utils/directives/permission.js"
import ZModalPlugin from '@/utils/plugins/zModel'
import request, { requestOptions } from '@/utils/request.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import './assets/css/common.scss'
import './assets/css/element-variables.scss'
import i18n from "./i18n"
import router from './router'
import store from './store'

Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false
Vue.use(ZModalPlugin)
// 挂载全局
Vue.prototype.$request = request
Vue.prototype.$requestOptions = requestOptions

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js